import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SUPERPOST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataPermit = createAsyncThunk(
    'PermitData/fetchDataPermit',
    async ({ cmpdetail, MenuId }, { rejectWithValue }) => {

        var requestData = CustomStringify({});

        try {
            const result = await SUPERPOST(`/permMenuRights?UserName=${cmpdetail?.userName}&CompID=${cmpdetail?.CompanyId}&MenuId=${MenuId}`, requestData);
            return result?.data[0]
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const PermitDataSlice = createSlice({
    name: 'PermitData',
    initialState: {
        result: {
            IsDelete: true,
            IsPrint: true,
            IsSave: true,
            IsShow: true,
            IsUpdate: true,
            IsSearch: true,
        },
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataPermit.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataPermit.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataPermit.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export default PermitDataSlice.reducer;